<template>
  <el-dialog
    v-drag
    :visible.sync="dialogVisible"
    title="提单附件"
    width="1200px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <BaseTable
        :height="500"
        :tableData="tableData"
        :isPager="false"
        :loading="false"
      >
        <div slot="opt" slot-scope="row" class="optbtn">
          <div title="查看" class="btn" @click="check(row.scope)">
            <i class="el-icon-zoom-in"></i>
          </div>
          <div title="下载" class="btn" @click="download(row.scope)">
            <i class="el-icon-download" />
          </div>
        </div>
      </BaseTable>
    </div>
  </el-dialog>
</template>
<script>
const BaseTable = () => import('@/components/table/BaseTable')

import { getMBLFileList } from '@/api/bill'
export default {
  components: { BaseTable },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      tableData: {
        fileds: [
          {
            filed: 'fileName',
            label: '文件名',
            width: ''
          },
          {
            filed: 'typeName',
            label: '文件类型',
            width: ''
          },
          {
            filed: 'createdOn',
            label: '上传时间',
            width: ''
          },
          {
            filed: 'createdName',
            label: '上传人',
            width: ''
          },
          {
            filed: 'opt',
            label: '操作',
            width: '120',
            isCustom: true
          }
        ],
        columns: [],
        total: 0
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getFileList()
      }
    }
  },
  methods: {
    check(item) {
      const suffix = item.fileName.slice(
        item.fileName.lastIndexOf('.') + 1,
        item.fileName.length
      )
      if (
        suffix.toLowerCase() === 'jpg' ||
        suffix.toLowerCase() === 'jpeg' ||
        suffix.toLowerCase() === 'png'
      ) {
        this.$viewerApi({
          images: [item.filePath]
        })
      } else if (suffix.toLowerCase() === 'pdf') {
        window.open(
          item.filePath
        )
      } else {
        this.$message.error('暂时只支持图片和PDF查看')
      }
    },
    download(v) {
      const elink = document.createElement('a')
      elink.style.display = 'none'
      elink.href = v.filePath
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    },
    async getFileList() {
        try {
          const res = await getMBLFileList({
            mblId: this.rowData.mblId
          })
          if (res.success) {
            this.tableData.columns = res.data
          } else {
            this.$message.error(res.errorMessage)
          }
        } catch (error) {
          console.log(error)
        }
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: calc(100% - 80px);
  height: auto;
  margin: 0 auto;
 .optbtn {
    display: flex;
    justify-content: space-around;
  }
  .btn {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color:  rgb(18,88,188);
    cursor: pointer;
    img {
      margin-right: 4px;
    }
    i {
      font-size: 18px;
      margin-right: 4px;
    }
  }
}
/deep/ .el-dialog__body {
  padding: 20px 20px;
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
